module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/socialProofPrograms-4ed7239ff097e68b23cbe44663461852.png";